// extracted by mini-css-extract-plugin
module.exports = {"main":"RecruitAdInsert_main__YNrG1","content":"RecruitAdInsert_content__Fy34I","cta":"RecruitAdInsert_cta__IG_mz","text":"RecruitAdInsert_text__HQl8G"};